import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody55';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy55 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;transform:scale(0.85);transform-origin:left;'>Cap Table Reconstruction</h2><h4>And Exit Returns Waterfall</h4>";

  return (
    <>
        <Helmet>
        <title>Cap Table Reconstruction And Exit Returns Waterfall </title>
        <meta property="og:title" content="Cap Table Reconstruction And Exit Returns Waterfall" />
        <meta property='og:description' content='Cap Table Reconstruction And Exit Returns Waterfall '/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy51" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy55
